import { config } from '../../config';

/**
 * function to get the booking data from the database
 * @returns {Array} An array of booking objects, or an empty array on failure.
 */
export async function getData() {
    try {
        const response = await fetch(`${config.API_BASE_URL}/api/booking/data`, {
            method: "GET",
        });

        // Check for HTTP errors (e.g., 404, 500) before parsing JSON
        if (!response.ok) {
            // console.error("HTTP Error:", response.status, response.statusText);
            alert(`Failed to retrieve data. Server status: ${response.status}`);
            return []; // Return empty array on network/HTTP error
        }

        const result = await response.json();
        console.log("getData result:", result);

        if (result.status === "success") {
            // console.log("Success:", result);

            //Return the actual booking data
            return result.bookings;

        } else {
            // Backend returned a non-success status (e.g., "no_data")
            // console.warn("Backend failed/no data:", result);
            // alert(`Failed: ${result.message || "Unknown error"}`);
            // alert("No Booking Data Available");

            return []; // Return empty array on backend logic failure
        }

    } catch (error) {
        // console.error("Error fetching data:", error);
        alert("A network or unexpected error occurred.");
        return []; // Return empty array on catastrophic failure
    }
}